export default {
  getUserData: ({ userData }) => userData,
  getOnboardingData: ({ onboardingData }) => onboardingData,
  getProfileData: ({ profileData }) => profileData
};
